
export class Foto {

    static path = 'subir_foto';
    file: File;
    path: string;
    id: number;
    name: string;
    archivoId: number;
    url?: any;
  
    constructor(file: File) {
      this.file = file;
    }
  }
  


// WEBPACK FOOTER //
// ./src/app/security/user/foto.model.ts